import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        schoolId: localStorage.getItem("schoolId"),
        schoolName: localStorage.getItem("schoolName"),
        
        url: "",
        socketUrl: "",
        
        students: [],
        pic_height: localStorage.getItem("pic_height"),
        pic_width: localStorage.getItem("pic_width"),
        rotation: localStorage.getItem("rotation"),
    },
    mutations: {
        login(state, data) {
            state.schoolId = data.id
            localStorage.setItem("schoolId", data.id)
            state.schoolName = data.name
            localStorage.setItem("schoolName", data.name)

            state.pic_height = data.pic_height
            localStorage.setItem("pic_height", data.pic_height)
            state.pic_width = data.pic_width
            localStorage.setItem("pic_width", data.pic_width)
            state.rotation = data.rotation
            localStorage.setItem("rotation", data.rotation)
        },
        logout(state) {
            state.schoolId = 0
            state.schoolName = ''
            localStorage.clear()
        },
        setStudents(state, data) {
            state.students = data
        },
        setUrl(state, data) {
            state.url = data
            // console.log("asiganda la url... ", state.url)
        },

        setEnv(state, env) {
            if (env === "dev") {
                state.url = "http://localhost:3500/api/"
                state.socketUrl = "http://localhost:3500/"
                // state.socketUrl = "http://127.0.0.1:3500/"
                // state.socketUrl = "127.0.0.1:3500/"
            } else {
                state.url = "https://atchecker.mecasite.com/api/"
                state.socketUrl = "https://atchecker.mecasite.com/"                
            }
        }
    },
    actions: {},
    modules: {}
})